import { Refresh } from '~/components/refresh'
import * as Comp from './switch-refresh.styles'

export function SwitchRefresh({ testID }: { testID?: string }) {
  return (
    <Comp.Container>
      <Refresh testID={testID} size="md" color="neutral" />
    </Comp.Container>
  )
}
